<mat-form-field [class]="getFieldSize()" appearance="outline" floatLabel="always">
  <mat-label>
    {{ label() | translate }}
  </mat-label>
  <mat-select [ngModel]="selectedOption" (ngModelChange)="updateSelectedOption($event)" (selectionChange)="handleChange()">
    @for (option of options(); track option) {
      <mat-option value="{{ option }}">
        {{ translationLocation ? (translationLocation + '.' + option | translate) : option }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
